import { Component, Output, EventEmitter, Input } from "@angular/core";

@Component({
  selector: "app-filter",
  templateUrl: "./filter.component.html",
  styleUrls: ["./filter.component.scss"]
})
export class FilterComponent {
  public searchString: string;
  @Output() filter: EventEmitter<string> = new EventEmitter();
  @Input() placeholder: string;

  handleFilter(value: string) {
    this.filter.emit(value);
  }
}
